module.exports = __webpack_public_path__ + "static/media/shape0_6.35188523.obj";